import { UserRoles } from '@/enums/enums';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { AuthUser } from '@/types/types';

const initialState: AuthUser = {
  id: null,
  username: '',
  role: UserRoles.Teacher,
  firstName: '',
  lastName: '',
  tenant: '',
  wsConfig: {
    channels: [],
  },
  permissions: {},
};

type SetPayload = {
  id: number | null;
  token: string | null;
  username: string;
  firstName: string;
  lastName: string;
  role: UserRoles;
  exp: number;
};

const getInitialState = (): AuthUser => {
  const user = localStorage.getItem('user') ?? null;

  if (user) {
    const authUser = JSON.parse(user);
    return {
      id: authUser.id,
      role: authUser.role,
      username: authUser.username,
      firstName: authUser.firstName,
      lastName: authUser.lastName,
      tenant: authUser.tenant,
      wsConfig: authUser.wsConfig,
      permissions: {},
    };
  }

  return initialState;
};

export const userSlice = createSlice({
  name: 'user',
  initialState: getInitialState(),
  reducers: {
    set: (state, action: PayloadAction<SetPayload>) => {
      const { id, token, username, firstName, lastName, role, exp } = action.payload;

      if (token !== null) {
        localStorage.setItem('token', token);
        localStorage.setItem(
          'user',
          JSON.stringify({
            id,
            username,
            firstName,
            lastName,
            role,
            exp,
          })
        );
        state.id = id;
        state.username = username;

        state.firstName = firstName;
        state.lastName = lastName;
        state.role = role;
      }
    },
    reset: () => {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      return initialState;
    },
  },
});

export const userActions = {
  set: userSlice.actions.set,
  reset: userSlice.actions.reset,
};

export default userSlice.reducer;
